module.exports = __webpack_public_path__ + "static/media/reportingDown.f4f4a96b.svg";